module.exports = __webpack_public_path__ + "img/shangmao.0ab5e60f.jpg";